import { render, staticRenderFns } from "./ZzqsBlock.vue?vue&type=template&id=55ff4622&scoped=true"
import script from "./ZzqsBlock.vue?vue&type=script&lang=js"
export * from "./ZzqsBlock.vue?vue&type=script&lang=js"
import style0 from "./ZzqsBlock.vue?vue&type=style&index=0&id=55ff4622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff4622",
  null
  
)

export default component.exports